export const GRAVITY = 1000;
// With bomb art in the images oriented to point down, this adjustment gets things oriented along the path of trajectory:
export const RADIANS_ADJUSTMENT = Math.PI / 2;
export function calcTrajectory(fromCoords, toCoords) {
    // for the math to work, the delta X needed to hit the target is always positive, but the delta Y can be negative:
    const absDeltaX = Math.abs(toCoords.x - fromCoords.x);
    const deltaY = fromCoords.y - toCoords.y;
    // start with a random-ish velocity:
    let velocity = Math.random() * 600 + 30;
    // TODO: See if we can algorithmically determine the minimum velocity required to hit the target, and use that as lower bound for random velocity selection.
    // retry with slightly higher velocities until an angle (radians) is found that can hit the target:
    let radians;
    do {
        velocity *= 1.5;
        radians = Math.atan((Math.pow(velocity, 2) +
            Math.sqrt(Math.pow(velocity, 4) - GRAVITY * (GRAVITY * Math.pow(absDeltaX, 2) + 2 * deltaY * Math.pow(velocity, 2)))) /
            (GRAVITY * absDeltaX));
    } while (isNaN(radians));
    // TODO: Handle this more robustly, like retry x times to get a valid shot, otherwise return null and do nothing.
    if (isNaN(radians)) {
        throw new Error('NaN');
    }
    const isGoingRight = toCoords.x > fromCoords.x;
    return { velocity, radians, isGoingRight };
}
/**
 * Uses properties from a calculated trajectory (from `getTrajectory()`) to find the X position at a specific time after launch.
 */
export function getXAtTime(elapsedTime, initialVelocity, fromX, radians, isGoingRight) {
    const deltaX = initialVelocity * elapsedTime * Math.cos(radians);
    return fromX + (isGoingRight ? deltaX : -deltaX);
}
/**
 * Uses properties from a calculated trajectory (from `getTrajectory()`) to find the Y position at a specific time after launch.
 */
export function getYAtTime(elapsedTime, initialVelocity, fromY, radians) {
    return fromY - (initialVelocity * elapsedTime * Math.sin(radians) - 0.5 * GRAVITY * Math.pow(elapsedTime, 2));
}
/**
 * Uses properties from a calculated trajectory (from `getTrajectory()`) to find the direction (rotation), velocity X and velocity Y at a specific time after launch.
 */
export function getVelocityComponentsAtTime(elapsedTime, initialVelocity, initialRadians, isGoingRight) {
    const velocityX = (isGoingRight ? 1 : -1) * initialVelocity * Math.cos(initialRadians);
    const velocityY = -(initialVelocity * Math.sin(initialRadians) - GRAVITY * elapsedTime);
    const radians = Math.atan(velocityY / velocityX) + (isGoingRight ? -1 : 1) * RADIANS_ADJUSTMENT;
    return { radians, velocityX, velocityY };
}
export function getFromSeatBounds(fromSeatIndex, allSeatBounds, tableAreaDimensions) {
    if (fromSeatIndex === undefined) {
        const randomNumber = Math.random();
        const seatDimensions = { w: allSeatBounds[0].w, h: allSeatBounds[0].h };
        if (randomNumber < 1 / 3) {
            // bomb comes from bottom
            return {
                ...seatDimensions,
                x: Math.random() * tableAreaDimensions.w,
                y: tableAreaDimensions.h + seatDimensions.h / 2
            };
        }
        else {
            // bomb comes from side (from bottom 2/3 of the table height)
            const y = Math.random() * tableAreaDimensions.h * (2 / 3) + tableAreaDimensions.h * (1 / 3);
            if (randomNumber < 2 / 3) {
                // bomb comes from left
                return {
                    ...seatDimensions,
                    x: -seatDimensions.w / 2,
                    y
                };
            }
            else {
                // bomb comes from right
                return {
                    ...seatDimensions,
                    x: tableAreaDimensions.w + seatDimensions.w / 2,
                    y
                };
            }
        }
    }
    return allSeatBounds[fromSeatIndex];
}
